module.exports = __webpack_public_path__ + "static/media/miniaturaVideoEquipamentos.62c58cfe.png";